'use strict';

var base = require('core/product/addToCartStickyBar');

base.addToCartStickyBar = function addToCartStickyBar() {
    //main add to cart sticky vars
    var SiteConstants = require('constants/SiteConstants');
    var addToCartStickyBar = document.getElementById('addtocart-sticky-bar');
    var addToCartContainer = document.getElementById('qty-cart-container');
    var $body = $('body');
    var topHeader = document.getElementById('top-header');

    //if header is fixed, use just the nav bar to measure top of page, else use the entire header (may contain promo bar)
    var topHeaderHeight;
    if (topHeader.classList.contains('fixed-header')) {
        topHeaderHeight = topHeader.offsetHeight;
    } else {
        topHeaderHeight = 0;
    }

    if (addToCartStickyBar && addToCartContainer) {
        var $addToCartContainer = $(addToCartContainer);
        var checkedCustomizerBtn = false;

        window.addEventListener('scrollUpdate', function () {
            //main sticky add to cart functionality - only show when scrolled past in-page add to cart section
            if (window.pageYOffset > ($addToCartContainer.offset().top + addToCartContainer.offsetHeight - topHeaderHeight)) {
                $body.addClass('showstickybar');
                addToCartStickyBar.setAttribute('style', 'top:' + topHeaderHeight + 'px;');

                if (!checkedCustomizerBtn) {
                    // Update Add to Cart button to be full width when the customizer button isn't present
                    var $addToCartStickyBar = $(addToCartStickyBar);
                    checkedCustomizerBtn = true;
                    if (!$addToCartStickyBar.find('.product-customize-button').length) {;
                        $addToCartStickyBar.find('.customizer-row').addClass('d-none');
                        $addToCartStickyBar.find('.add-to-cart').closest('.row').addClass('flex-fill');
                    }
                }
            } else if ($body.hasClass('showstickybar')) {
                $body.removeClass('showstickybar');
                setTimeout(() => {
                    addToCartStickyBar.removeAttribute('style');
                }, SiteConstants.TransitionSpeed);
            }
        });

        $('.addtocart-sticky-bar .sticky-bar-links a').click(function(event) {
            event.preventDefault();

            var target = $(this.hash),
                hashValue = this.hash.slice(1),
                fixValue = 0,
                headerHeight = $('#top-header').outerHeight(),
                stickyNavHeight = $('.addtocart-sticky-bar').outerHeight(),
                scrollToValue = 0;

            if (hashValue === 'back-to-top') {
                $('html, body').animate({
                    scrollTop: 0
                }, 800);
            } else {
                target = $('[name=' + hashValue + ']');

                if (target.length) {
                    fixValue = headerHeight + stickyNavHeight;
                    scrollToValue = target.offset().top - fixValue;

                    $('html, body').animate({
                        scrollTop: scrollToValue
                    }, 800);
                }
            }
        });
    }
};

module.exports = base;